import { Outlet } from 'react-router-dom'
import { useMemo } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useUIStore } from '@/store/useUIStore'
import { useAuthStore } from '@/store/useAuthStore'
import { getSchoolAdminNav } from './navConfig'

export function SchoolAdminLayout() {
  const sidebarOpen = useUIStore(s => s.sidebarOpen)
  const user = useAuthStore(s => s.user)

  // Visibility mirrors the original: filter the menu by the school admin's
  // permissions, falling back to the full menu when none are attached.
  const sections = useMemo(() => {
    const permissions = user?.school_admin_roles
      ?.flatMap(r => r.role?.permissions?.map(p => p.name) ?? [])
      .filter(Boolean) as string[] | undefined
    return getSchoolAdminNav(permissions)
  }, [user])

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar sections={sections} open={sidebarOpen}/>
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Header/>
        <main id="main-scroll-area" className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="p-3 sm:p-5">
            <Outlet/>
          </div>
        </main>
      </div>
    </div>
  )
}
